import { useCallback, useState } from "react";
import { request } from "../../httpClient";

export const useArticleSet = () => {
  const [articleSetLoading, setArticleListLoading] = useState(false);

  const articleSetReq = useCallback(async (values) => {
    setArticleListLoading(true);
    const fd = new FormData();
    for (let value in values) {
      if (values[value] && ["image", "video"].includes(value)) {
        fd.append(value, values[value][0]);
      } else {
        fd.append(value, values[value] ? values[value] : "");
      }
    }
    try {
      const res = await request({
        path: "promoblock/add",
        method: "POST",
        body: fd,
        requestType: null,
      });
      setArticleListLoading(false);
      return res?.data;
    } catch (err) {
      setArticleListLoading(false);
      return {};
    }
  }, []);

  return { articleSetReq, articleSetLoading };
};
